import React from 'react';

const IMG = {
  equipment: 'https://images.pexels.com/photos/139398/thermometer-headache-pain-pills-139398.jpeg?auto=compress&cs=tinysrgb&w=1200', // Pexels medical image
};

const HomeBanner: React.FC = () => (
  <section className="w-full bg-primary flex flex-col md:flex-row overflow-hidden min-h-[320px] sm:min-h-[400px]">
    {/* Left Side: Image */}
    <div className="w-full md:w-[45%] h-[220px] sm:h-[300px] md:h-auto md:min-h-[400px] relative">
      <img 
        src={IMG.equipment} 
        alt="Medical equipment" 
        className="absolute inset-0 w-full h-full object-cover" 
      />
    </div>

    {/* Right Side: Content & Form */}
    <div className="w-full md:w-[55%] p-6 sm:p-10 md:p-16 lg:p-24 flex flex-col justify-center max-w-2xl">
      <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#EAB308] mb-3 sm:mb-4 tracking-wide">
        Subscribe to our newsletter :)
      </h2>
      <p className="text-white/90 text-sm sm:text-[15px] leading-relaxed mb-6 sm:mb-8 max-w-lg font-medium">
        Do you sometimes have the feeling that you're running into the same obstacles over and over again? Subscribe to get industry-leading medical insights.
      </p>

      {/* Input Form */}
      <form 
        className="flex items-center bg-white overflow-hidden max-w-sm" 
        onSubmit={e => e.preventDefault()}
      >
        <input 
          type="email" 
          placeholder="your@email.com" 
          className="flex-1 py-3 px-4 text-sm text-[#008080] placeholder-[#008080]/60 outline-none w-full font-medium"
          required
        />
        <button 
          type="submit" 
          aria-label="Subscribe"
          className="px-4 py-3 text-[#008080] hover:bg-gray-50 transition-colors flex items-center justify-center bg-white"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="translate-y-px">
            <path d="M9 18l6-6-6-6" />
            <path d="M15 12H3" />
          </svg>
        </button>
      </form>
    </div>
  </section>
);

export default HomeBanner;
